import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CommonState, interfaceOf, Offer, Reward } from "@obg/ngx.common";
import { Jurisdiction, JurisdictionSelector } from "@obg/ngx.core";
import { ignoreNil } from "@obg/rxjs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-m-bonus-selection",
	templateUrl: "./bonus-selection.component.html",
	styleUrls: ["./bonus-selection.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class BonusSelectionComponent implements OnInit {
	@HostBinding("class.obg-m-bonus-selection") hostClass = true;

	@Input() items: (Offer | Reward)[] | undefined;
	/**
	 * Emits `undefined` when deposit without button is clicked
	 */
	@Output() itemSelected = new EventEmitter<Offer | Reward | undefined>();

	divider$: Observable<boolean> | undefined;

	constructor(private store: Store<CommonState>) {}

	ngOnInit() {
		this.divider$ = this.store.pipe(
			select(JurisdictionSelector.get),
			ignoreNil(),
			map((jurisdiction) => jurisdiction !== Jurisdiction.Cgl)
		);
	}

	itemTrackBy(_index: number, item: Offer | Reward): string | undefined {
		return interfaceOf<Reward>(item, "identifier") ? item.identifier : item.id;
	}
}
